import { putRequest } from '../../axios/requests';
import API from '../../constant.api';

export interface ChangePasswordPayload {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

// PUT /users/me/password (Authorization: Bearer <token> is attached by requests.ts)
export const changeMyPassword = async (
  payload: ChangePasswordPayload
): Promise<{ message: string }> => {
  const { data } = await putRequest(`${API.USERS}/me/password`, payload);
  return data;
};
